import React from "react";
import { Card, Col, Divider, Row, Typography } from "antd";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    recurringDepositDetails,
    lockinPeriodFrequencyTypeOptions,
  } = props;
  console.log(formData);

  const data = {
    details: [
      {
        name: "Product Name",
        value: formData?.details?.name ? formData.details.name : " - ",
      },
      {
        name: "Short Name",
        value: formData?.details?.shortName
          ? formData.details.shortName
          : " - ",
      },
      {
        name: "Description",
        value: formData?.details?.description
          ? formData.details.description
          : " - ",
      },
    ],
    currency: [
      {
        name: "Currency",
        value: formData?.currency?.currencyCode
          ? formData.currency.currencyCode
          : " - ",
      },
      {
        name: "Decimal Places",
        value: formData?.currency?.digitsAfterDecimal
          ? formData.currency.digitsAfterDecimal
          : " - ",
      },
      {
        name: "Currency In Multiples Of",
        value: formData?.currency?.inMultiplesOf
          ? formData.currency.inMultiplesOf
          : " - ",
      },
    ],
    terms: [
      {
        name: "Default Deposit Amount",
        value: formData?.terms?.depositAmount
          ? formData?.terms?.depositAmount.toLocaleString()
          : " - ",
      },
      {
        name: "Minimum Deposit Amount",
        value: formData?.terms?.minDepositAmount
          ? formData?.terms?.minDepositAmount.toLocaleString()
          : " - ",
      },
      {
        name: "Maximum Deposit Amount",
        value: formData?.terms?.maxDepositAmount
          ? formData?.terms?.maxDepositAmount.toLocaleString()
          : " - ",
      },
      {
        name: "Interest Compounding Period",
        value: formData?.terms?.interestCompoundingPeriodType
          ? recurringDepositDetails?.interestCompoundingPeriodTypeOptions?.find(
              (item) =>
                item.id === formData?.terms?.interestCompoundingPeriodType
            )?.value
          : " - ",
      },
      {
        name: "Interest Posting Period",
        value: formData?.terms?.interestPostingPeriodType
          ? recurringDepositDetails?.interestPostingPeriodTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestPostingPeriodType
            )?.value
          : " - ",
      },
      ,
      {
        name: "Interest Calculated Using",
        value: formData?.terms?.interestCalculationType
          ? recurringDepositDetails?.interestCalculationTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestCalculationType
            )?.value
          : " - ",
      },
      {
        name: "Days In Year",
        value: formData?.terms?.interestCalculationDaysInYearType
          ? formData.terms.interestCalculationDaysInYearType
          : " - ",
      },
    ],
    settings: [
      {
        name: "Lock-in Period",
        value: formData?.settings?.lockinPeriodFrequency
          ? `${formData.settings.lockinPeriodFrequency} ${
              recurringDepositDetails?.lockinPeriodFrequencyTypeOptions?.find(
                (item) =>
                  item.id === formData?.settings?.lockinPeriodFrequencyType
              )?.value
            }`
          : " - ",
      },
      {
        name: "Minimum Deposit Term",
        value: formData?.settings?.minDepositTerm
          ? `${formData.settings.minDepositTerm} ${
              recurringDepositDetails?.periodFrequencyTypeOptions?.find(
                (item) => item.id === formData?.settings?.minDepositTermTypeId
              )?.value
            }`
          : " - ",
      },
      {
        name: "And Thereafter, In Multiples Of",
        value: formData?.settings?.inMultiplesOfDepositTerm
          ? `${formData.settings.inMultiplesOfDepositTerm} ${
              recurringDepositDetails?.periodFrequencyTypeOptions?.find(
                (item) =>
                  item.id === formData?.settings?.inMultiplesOfDepositTermTypeId
              )?.value
            }`
          : " - ",
      },
      {
        name: "Maximum Deposit Term",
        value: formData?.settings?.maxDepositTerm
          ? `${formData.settings.maxDepositTerm} ${
              recurringDepositDetails?.periodFrequencyTypeOptions?.find(
                (item) => item.id === formData?.settings?.maxDepositTermTypeId
              )?.value
            }`
          : " - ",
      },
      {
        name: "Apply Penal Interest (less)",
        value: formData?.settings?.preClosurePenalInterest
          ? `${formData.settings.preClosurePenalInterest}% ${
              recurringDepositDetails?.preClosurePenalInterestOnTypeOptions?.find(
                (item) =>
                  item.id ===
                  formData?.settings?.preClosurePenalInterestOnTypeId
              )?.value
            }`
          : " - ",
      },
      {
        name: "Is Withhold Tax Applicable?",
        value: formData?.settings?.withHoldTax ? "true" : "false",
      },
      {
        name: "Withhold Tax group",
        value: formData?.settings?.taxGroupId
          ? recurringDepositDetails?.taxGroupOptions?.find(
              (item) => item.id === formData?.settings?.taxGroupId
            )?.name
          : " - ",
      },
    ],
    accounting: [
      {
        name: "Deposit Reference",
        value: formData?.accounting?.savingsReferenceAccountId
          ? recurringDepositDetails?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) =>
                item.id === formData?.accounting?.savingsReferenceAccountId
            )?.name
          : " - ",
      },
      {
        name: "Deposit Control",
        value: formData?.accounting?.savingsControlAccountId
          ? recurringDepositDetails?.accountingMappingOptions?.liabilityAccountOptions?.find(
              (item) =>
                item.id === formData?.accounting?.savingsControlAccountId
            )?.name
          : " - ",
      },
      {
        name: "Transfers In Suspense",
        value: formData?.accounting?.transfersInSuspenseAccountId
          ? recurringDepositDetails?.accountingMappingOptions?.liabilityAccountOptions?.find(
              (item) =>
                item.id === formData?.accounting?.transfersInSuspenseAccountId
            )?.name
          : " - ",
      },
      {
        name: "Interest On Savings",
        value: formData?.accounting?.interestOnSavingsAccountId
          ? recurringDepositDetails?.accountingMappingOptions?.expenseAccountOptions?.find(
              (item) =>
                item.id === formData?.accounting?.interestOnSavingsAccountId
            )?.name
          : " - ",
      },
      {
        name: "Income From Fees",
        value: formData?.accounting?.incomeFromFeeAccountId
          ? recurringDepositDetails?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.accounting?.incomeFromFeeAccountId
            )?.name
          : " - ",
      },
      {
        name: "Income From Penalties",
        value: formData?.accounting?.incomeFromPenaltyAccountId
          ? recurringDepositDetails?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) =>
                item.id === formData?.accounting?.incomeFromPenaltyAccountId
            )?.name
          : " - ",
      },
    ],
  };
  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* DETAILS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Details"}
        </Divider>
        {data.details.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* CURRENCY FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Currency"}
        </Divider>
        {data.currency.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* TERMS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Terms"}
        </Divider>
        {data.terms.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* SETTINGS FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Settings"}
        </Divider>
        {data.settings.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* ACCOUNTING FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Accounting"}
        </Divider>
        {data.accounting.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default Preview;
